import dynamic from "next/dynamic";

const CustomTable = dynamic(() => import("../table/CustomTable"), {
  ssr: false,
});

const Table = {
  Renderer: (props) => <CustomTable {...props} />,
  id: "Table",
  version: "Table",
  title: "Table",
};

export default Table;
